import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { ToggleMenu } from '@ignitesales/neuro-application/src/neuro-ui';
import {useGuideConfig, NeuroMessage, useDispatch, useNeuroState} from '@ignitesales/neuro-application';
import FormInput from "@ignitesales/neuro-application/src/neuro-guide/components/Forms/FormInput";
import FormContainer from "@ignitesales/neuro-application/src/neuro-guide/components/Forms/FormContainer";
import {setThemeConfiguration} from "../state/DialogueActions.mjs";

const ThemeRunnerTool = ({ enableMenu, onMenuClose }) => {
    const { isMockMode, runMode } = useGuideConfig();
    const { themeColors, isFdicMember, isEhlMember, hideActions } = useNeuroState();
    const dispatch = useDispatch();
    const [showMenu, setShowMenu] = useState(false);
    const componentClass = 'themeRunnerTool';
    const menuIsOpen = showMenu || enableMenu;
    const isDevelopmentMode = runMode === 'development';
    const toggleButtonClass = classnames(`${componentClass}__menuBtn`, {
        menuIsOpen: menuIsOpen,
    });

    const onToolMenuClose = () => {
        setShowMenu(false);
        onMenuClose && onMenuClose();
    };

    const colorEditorFormId = 'themeRunnerColorEditor';
    const fdicEditorFormId = 'themeRunnerFdicEditor';
    const ehlEditorFormId = 'themeRunnerEhlEditor';
    const hideActionsEditorFormId = 'themeRunnerHideActionsEditor';

    const onColorFormSubmit = data => {
      dispatch( setThemeConfiguration(data) );
    };

    return (
        (isMockMode || isDevelopmentMode) && (
            <>
                {enableMenu === undefined && (
                    <button role="button" title="Theme Runner Menu" className={toggleButtonClass} onClick={() => setShowMenu(!showMenu)}>
                        <i className="fa fa-paint-brush" />
                    </button>
                )}

                <ToggleMenu className={componentClass} animation="slideFromRight" isOpen={menuIsOpen} onOuterClick={onToolMenuClose}>
                    <i className={`fa fa-times ${componentClass}__closeBtn`} onClick={onToolMenuClose}/>
                    <div className={`${componentClass}__header`} role="complementary" aria-label="Development Tool Header">
                        <NeuroMessage id="themeTool.subtitle" tagName="span" />
                        <NeuroMessage id="themeTool.title" tagName="h1" />
                    </div>

                    <div className={`${componentClass}__content`}>
                        <div>
                            <NeuroMessage id="themeTool.propertiesEditor" tagName="h5" />
                            <FormContainer onSubmit={onColorFormSubmit} formId={colorEditorFormId} renderDefaultSubmit={true}>
                                <FormInput
                                    formId={colorEditorFormId}
                                    initialValue={themeColors?.primaryColor}
                                    errorPositionAfterInput
                                    name="primaryColor"
                                    required={true}
                                />
                                <FormInput
                                    formId={colorEditorFormId}
                                    initialValue={themeColors?.secondaryColor}
                                    errorPositionAfterInput
                                    name="secondaryColor"
                                    required={true}
                                />
                                <FormInput
                                    formId={fdicEditorFormId}
                                    initialValue={isFdicMember || false}
                                    type="checkbox"
                                    name="isFdicMember"
                                />
                                <FormInput
                                    formId={ehlEditorFormId}
                                    initialValue={isEhlMember || false}
                                    type="checkbox"
                                    name="isEhlMember"
                                />
                                <FormInput
                                    formId={hideActionsEditorFormId}
                                    initialValue={hideActions || false}
                                    type="checkbox"
                                    name="hideActions"
                                />
                            </FormContainer>
                        </div>
                    </div>
                </ToggleMenu>
            </>
        )
    );
};

ThemeRunnerTool.propTypes = {
    enableForAnyEnvironment: PropTypes.bool,
    enableMenu: PropTypes.bool,
    isConversationTestPage: PropTypes.bool,
    onMenuClose: PropTypes.func,
};
export default ThemeRunnerTool;
